import { api } from "@/utils/api";

export default class MmsRepository {
    async getModelVersions(locationId: string) {
      try {
        const response = await api.get(`mms/model/versions`, {
            params: {
                locationId
            }
        });
        return response.data;
      } catch (error) {
        console.error(error);
      }
    }
  }
  